import { colors } from '../colors';

const HeroSection = () => {
    return (
        <section style={{ backgroundColor: colors.accent, padding: '4rem 2rem', textAlign: 'center' }}>
            <h1 style={{ color: colors.primary, fontSize: '3rem', marginBottom: '1rem' }}>
                Simpler planning for teachers
            </h1>
            <p style={{ color: colors.primary, fontSize: '1.5rem', maxWidth: '600px', margin: '0 auto 2rem auto' }}>
                Empowering schools and teachers to collaboratively build, share, and teach engaging lesson plans.
            </p>
            {/* <a
                href="https://app.planna.education/signup"
                style={{
                    display: 'inline-block',
                    backgroundColor: colors.textPrimary, // dark button color
                    color: colors.backgroundSecondary,
                    padding: '1rem 2rem',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                Get Started for Free
            </a> */}
            <div
                // href="https://app.planna.education/signup"
                style={{
                    display: 'inline-block',
                    backgroundColor: colors.textPrimary, // dark button color
                    color: colors.backgroundSecondary,
                    padding: '1rem 2rem',
                    // cursor: 'pointer',
                    borderRadius: '8px',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                Signups coming soon
            </div>
        </section>
    );
};

export default HeroSection;
